"use client";

import { useMutation } from "@tanstack/react-query";
import { handleApiErrorResponse } from "@/lib/apiErrorHandler";

export function useRequestPasswordResetMutation() {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await fetch("/api/v1/auth/password-reset/request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) throw await handleApiErrorResponse(response);
      return response.json();
    },
  });
}

export function useValidateResetTokenQuery(token: string | null) {
  return {
    queryFn: async () => {
      if (!token) throw new Error("No token provided.");
      const response = await fetch(
        `/api/v1/auth/password-reset/validate?token=${encodeURIComponent(token)}`,
      );
      if (!response.ok) throw await handleApiErrorResponse(response);
      return response.json();
    },
  };
}

export function useConfirmPasswordResetMutation() {
  return useMutation({
    mutationFn: async ({
      token,
      newPassword,
    }: {
      token: string;
      newPassword: string;
    }) => {
      const response = await fetch("/api/v1/auth/password-reset/confirm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword }),
      });
      if (!response.ok) throw await handleApiErrorResponse(response);
      return response.json();
    },
  });
}
